import { Grid } from '@mui/material';
import { TimeWindow } from '@nx-smartmonkey/shared/interfaces';
import { useState } from 'react';
import Button from '../../../react-components/Button';
import { RoutalTimeWindowInput } from '../../../react-components/InputTimeWindow';
import { Text } from '../../../react-components/Text';

interface RegisterWorkScheduleProps {
  workSchedule: TimeWindow;
  nextStep: (workSchedule: TimeWindow) => void;
}

export const RegisterWorkSchedule = ({ workSchedule: initialWorkSchedule, nextStep }: RegisterWorkScheduleProps) => {
  const [workSchedule, setWorkSchedule] = useState<TimeWindow>(initialWorkSchedule);

  return (
    <Grid container flexDirection="column" gap="24px">
      <Grid>
        <Text
          intlId="drivers.register.work_schedule.title"
          variant="h6"
          style={{ marginBottom: `24px`, textAlign: `center` }}
        />
        <RoutalTimeWindowInput timeWindow={workSchedule} onTimewindowChange={setWorkSchedule} />
      </Grid>

      <Button
        disabled={!workSchedule}
        onClick={() => nextStep && nextStep(workSchedule)}
        intlId="drivers.register.next"
        style={{
          fontSize: `14px`,
          fontWeight: 400,
        }}
      />
    </Grid>
  );
};
